module.exports = __webpack_public_path__ + "media/components/country-flag/static/cc-29810fbfb81b30428894cecbd4305cbb.svg";